import { ProductBoxRegistrationModel } from 'app/shared/components/product-box/models/server';

import { ContainerMeasurementModel } from './server/container-measurement-model';

export interface ContainerMeasurement {
    employeeNumber: number;

    activityNumber: number;

    containerNumber: number;

    registrationTimestamp: number;

    productBoxRegistrations: ProductBoxRegistrationModel[];

    amountResult?: number;
}

export const mapContainerMeasurementToModel = ({
    activityNumber,
    containerNumber,
    employeeNumber,
    productBoxRegistrations,
    registrationTimestamp,
    amountResult,
}: ContainerMeasurement): ContainerMeasurementModel => {
    return {
        activityNumber,
        containerNumber,
        employeeNumber,
        productBoxRegistrations,
        registrationTimestamp: new Date(registrationTimestamp),
        result: amountResult,
    };
};
